module.exports = __webpack_public_path__ + "img/world-3.e345ff9f.png";